import { Box } from "@material-ui/core";
import TabTitle from "./tab-item";
import { IHall } from "../../interfaces";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/authReducer";
import { useMemo } from "react";
import { findPermissionOr } from "../../utils/find";

export const tabTitles = [
    "info", // 0
    "packets", // 1
    "tables", // 2
    "jackpots", // 3
    "binding", // 4
    "limits", // 5
    "math", // 6
    "hotkeys", // 7
    "stat", // 8
    "cards", // 9
    "payouts", // 10
    "payments", // 11
    "wager", // 12
    "paymetSystems", // 13
];

interface TabTitlesProps {
    setTab: (id: number) => void;
    currentTab: number;
    hall?: IHall;
    isChange: boolean;
};

const TabTitles: React.FC<TabTitlesProps> = ({ setTab, currentTab, hall, isChange }) => {
    const {
        role: { item: userRole },
        assigments: { items },
    } = useSelector(authSelector);
    const isNotCashier = useMemo(() => userRole && userRole !== "cashier", [userRole]);
    const isNotReferral = useMemo(() => userRole && userRole !== "referral", [userRole]);
    const isAdmin = useMemo(() => userRole && userRole === "administrator", [userRole]);
    const canShowMath = useMemo(() => findPermissionOr(items, ["showHallMath", "showChildrenHallMath"]), [items]);
    const canUpdateMath = useMemo(() => findPermissionOr(items, ["updateHallMath", "updateChildrenHallMath"]), [items]);
    const canViewWagers = useMemo(() => items.includes("viewHallWager"), [items]);
    const canDoMath = useMemo(() => isChange ? canUpdateMath : canShowMath, [isChange, canUpdateMath, canShowMath]);
    const conditions = useMemo(() => [
        true, // 0
        true, // 1
        true, // 2
        isNotCashier && isNotReferral, // 3
        isNotCashier && isNotReferral, // 4
        false, // 5
        canDoMath, // 6
        false, // 7
        isNotReferral && isNotCashier && !isChange, // 8
        !!hall && (hall.cards & 1) === 1, // 9
        !isChange && !!hall && (hall.cards & 2) === 2, // 10
        isNotReferral && !isChange && !!hall && !!hall.registration_code, // 11
        isNotReferral && canViewWagers, // 12
        isAdmin && hall && !!hall.registration_code, // 13
    ], [isNotCashier, hall, isChange, canDoMath, canViewWagers, isAdmin, isNotReferral]);
    return <Box className="tabs" display="flex" justifyContent="flex-start" style={{ overflowX: "auto", width: "100%" }} >
        {tabTitles.map((_, idx) => {
            return conditions[idx] && <TabTitle key={idx} tab={idx} setTab={setTab} currentTab={currentTab} />
        })}
    </Box>;
}

export default TabTitles;